var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import React, { useMemo, useRef } from 'react';
import ReactModal from 'react-modal';
import ReactPlayer from 'react-player';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { get } from 'lodash';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import uniqueID from "../../../shared/uniqueID";

import { WebMediaResourceForm } from "../../Attachments/components/WebMediaResourceForm";
import { uploadLocalAttachment } from "../actions/supportingFilesActions";
import { mimeTypeFromUrl } from "../../../api/files/extensionHelper";
import { MediaModalFileList } from "./MediaModalFileList";
import { MediaModalUploadFileButton } from "./MediaModalUploadFileButton";var

MediaModalType;(function (MediaModalType) {MediaModalType[MediaModalType["Image"] = 0] = "Image";MediaModalType[MediaModalType["Media"] = 1] = "Media";})(MediaModalType || (MediaModalType = {}));




const getAcceptedFileTypes = (type) =>
type === MediaModalType.Image ? 'image/*' : 'video/*';













const mapStateToProps = (state, ownProps) => {
  const model = ownProps.formModel;
  return {
    entity: get(state, model)
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{ localAttachmentAction: uploadLocalAttachment, rrfChange: formActions.change },
dispatch);


const connector = connect(mapStateToProps, mapDispatchToProps);




function filterAttachments(
type,
attachments)
{
  const filteredAttachments = attachments.map((a) => {
    const mimetype = a.url && !a.mimetype ? mimeTypeFromUrl(a.url) : a.mimetype;
    return _objectSpread(_objectSpread({}, a), {}, { mimetype });
  });
  switch (type) {
    case MediaModalType.Image:
      return filteredAttachments.filter((a) => a.mimetype && a.mimetype.includes('image'));
    case MediaModalType.Media:
      return filteredAttachments.filter(
      (a) =>
      a.mimetype && (a.mimetype.includes('video') || a.mimetype.includes('audio')) ||
      a.url && ReactPlayer.canPlay(a.url));

    default:
      return attachments;}

}

const MediaModalComponent = ({
  isOpen,
  attachments = [],
  selectedUrl,
  entity,
  formModel,
  formField,
  type,
  multipleEdition,
  onClose,
  onChange,
  localAttachmentAction,
  rrfChange
}) => {
  const filteredAttachments = useMemo(
  () => filterAttachments(type, attachments),
  [attachments, type]);


  const inputFileRef = useRef(null);

  const handleAttachmentClick = (url) => () => {
    onChange(url);
    onClose();
  };

  const handleSubmitFromUrl = (formData) => {
    onChange(formData.url);
    onClose();
  };

  const handleFileInPublicForm = (event) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const data = { data: URL.createObjectURL(files[0]), originalFile: files[0] };
      onChange(data);
      onClose();
    }
  };

  const handleUploadButtonClicked = () => {var _inputFileRef$current;
    (_inputFileRef$current = inputFileRef.current) === null || _inputFileRef$current === void 0 ? void 0 : _inputFileRef$current.click();
  };

  const handleInputFileChange = async (event) => {
    const [file] = event.target.files || [];

    if (file) {
      const fileLocalID = uniqueID();

      localAttachmentAction(
      entity.sharedId || 'NEW_ENTITY',
      file,
      {
        __reducerKey: 'library',
        model: formModel
      },
      fileLocalID);

      rrfChange(formField, fileLocalID);
      onClose();
    }
  };

  return /*#__PURE__*/(
    _jsx(ReactModal, {
      isOpen: isOpen,
      className: "attachments-modal",
      overlayClassName: "attachments-modal__overlay",
      ariaHideApp: false }, void 0, /*#__PURE__*/

    _jsx("div", { className: "attachments-modal__header" }, void 0, /*#__PURE__*/
    _jsx("h4", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Supporting files")), /*#__PURE__*/


    _jsx("button", { type: "button", onClick: onClose, className: "attachments-modal__close" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Close")))), /*#__PURE__*/



    _jsx("div", { className: "attachments-modal__content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "attachments-modal__tabs-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "upload-options" }, void 0,
    !multipleEdition && /*#__PURE__*/
    _jsx(MediaModalUploadFileButton, {
      formModel: formModel,
      acceptedFileTypes: getAcceptedFileTypes(type),
      inputFileRef: inputFileRef,
      handleUploadButtonClicked: handleUploadButtonClicked,
      handleFileInPublicForm: handleFileInPublicForm,
      handleInputFileChange: handleInputFileChange }),


    !multipleEdition && /*#__PURE__*/_jsx(Translate, {}, void 0, "or"), /*#__PURE__*/
    _jsx("div", { className: "wrapper-web" }, void 0, /*#__PURE__*/
    _jsx(WebMediaResourceForm, { handleSubmit: handleSubmitFromUrl }))), /*#__PURE__*/


    _jsx("div", {
      className: `tab-content attachments-modal__tabs-content ${
      !filteredAttachments.length ? 'centered' : ''
      }` }, void 0, /*#__PURE__*/

    _jsx(MediaModalFileList, {
      filteredAttachments: filteredAttachments,
      handleAttachmentClick: handleAttachmentClick,
      selectedUrl: selectedUrl || '' }))))));






};

const container = connector(MediaModalComponent);


export { MediaModalType, container as MediaModal };